export const buttonStyles = (selected: boolean) => ({
	width: '5.5rem',
	height: '3rem',
	border: '0.0625rem',
	borderStyle: 'solid',
	borderRadius: '0.5rem',
	borderColor: selected ? 'secondary.main' : 'neutrals.primary',
	'&:hover': {
		borderColor: 'secondary.main',
	},
	...(selected && {
		outline: '0.0625rem',
		outlineStyle: 'solid',
		outlineColor: 'secondary.main',
	}),
	textTransform: 'none',
	backgroundColor: 'backgrounds.default',
});

export const checkIconStyles = {
	height: '0.75rem',
	width: '0.75rem',
	position: 'absolute',
	color: 'secondary.main',
	top: '0.0625rem',
	right: '0.0625rem',
};
